module.exports = __webpack_public_path__ + "img/店铺业绩.002c426d.svg";